import { render, staticRenderFns } from "./TreeviewItem.vue?vue&type=template&id=41ed7b59&scoped=true&"
import script from "./TreeviewItem.vue?vue&type=script&lang=js&"
export * from "./TreeviewItem.vue?vue&type=script&lang=js&"
import style0 from "./TreeviewItem.vue?vue&type=style&index=0&id=41ed7b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed7b59",
  null
  
)

export default component.exports